import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import styles from './style.module.css';
import clsx from "clsx";
import close from "../../../assets/close.svg";
import { PriceDetailsOpen, SetViewOrderPickupDropoffDetails } from "../../../Redux/actions/actionNames";
import dropofft1 from "../../../assets/dropofft1.svg";
import pickupt1 from "../../../assets/pickupt1.svg";
import schedulet1 from "../../../assets/schedulet1.svg";
import personv from "../../../assets/personv.svg";
import call from "../../../assets/call.svg";
import email from "../../../assets/email_color.svg";

import notesv1 from "../../../assets/notesv1.svg";
import ic_no_photo from "../../../assets/ic_no_photo.svg";

import { isOrderInDone } from "../../../helper/module";
import { isArray, isEmpty } from "lodash";
import { checkTimestamp, get_calendarType, get_dateFormat, get_id, get_lang, get_timeFormat } from "../../../helper/UserData/userdate";
import { Voip_OutgoingCall } from "../../../Redux/actions/actions";

import pickupdot from "../../../assets/pickupdot.svg";
import dropoffdot from "../../../assets/dropoffdot.svg";
import Typography from "../../../design-system/lib/Typography";
import { Attach, AttachColor, CALL, Customer, DONE_CIRCLE, Deliveryonly_deactive, Eye, FORWARD, Failed, PickupOnly_Deactive, Routes_deactive, TIMER, calendar_gray, calendar_time_gray, email_color, hashtag2, ic_fail, ic_zoning, input, list_gray } from "../../../assets";
import IconProvider from "../../../design-system/lib/IconProvider";
import Button from "../../../design-system/lib/Button";
import history from "../../../service/history";
import Tag from "../../../design-system/lib/Tag";
import jalali from "jalali-moment";
import momentJalaali from "moment-jalaali";
import ic_barcode_scanned from "../../../assets/IconProvider/ic_barcode_scanned.svg";
import EllipisWithTooltip from "../../../design-system/lib/ellipsis-with-tooltip";


class App extends React.Component {

  close = () => {
    this.props.dispatch(SetViewOrderPickupDropoffDetails(null))
  }


  reserveIsValid() {
    return this.props.pickup_dropoff_details.data
      ? (this.props.pickup_dropoff_details.data.scheduleDateBefore
        ? momentJalaali(this.props.pickup_dropoff_details.data.scheduleDateBefore).isValid()
        : false) ||
      (this.props.pickup_dropoff_details.data.scheduleDateAfter
        ? momentJalaali(this.props.pickup_dropoff_details.data.scheduleDateAfter).isValid()
        : false)
      : false;
  }

  reserveToText() {
    return `${this.getTodayTomorowYesterday(this.props.pickup_dropoff_details.data.scheduleDateAfter)} - ${momentJalaali(this.props.pickup_dropoff_details.data.scheduleDateBefore).locale(get_lang()).format(get_timeFormat())}`
  }



  reservePHUBDIsValid() {
    return this.props.pickup_dropoff_details.data
      ? (this.props.pickup_dropoff_details.data.completeBefore
        ? momentJalaali(this.props.pickup_dropoff_details.data.completeBefore).isValid()
        : false) ||
      (this.props.pickup_dropoff_details.data.completeAfter
        ? momentJalaali(this.props.pickup_dropoff_details.data.completeAfter).isValid()
        : false)
      : false;
  }

  reservePHUBDToText() {
    return `${momentJalaali(this.props.pickup_dropoff_details.data.completeAfter).locale(get_lang()).format(checkTimestamp(this.props.pickup_dropoff_details.data.completeAfter))} - ${momentJalaali(this.props.pickup_dropoff_details.data.completeBefore).locale(get_lang()).format(get_timeFormat())}`
  }




  makeOutgoingCall = () => {
    let data = this.props.pickup_dropoff_details && this.props.pickup_dropoff_details.data

    this.props.dispatch(Voip_OutgoingCall(this.props.dispatch, {
      "to": data.phone,
      "orderId": this.props.Data.id,
      "customerId": null,
      "driverId": null,
      "dispatcherId": get_id()
    }))
  }

  makeOutgoingCall_Driver = () => {
    let data = this.props.pickup_dropoff_details && this.props.pickup_dropoff_details.data

    this.props.dispatch(Voip_OutgoingCall(this.props.dispatch, {
      "to": data.driver.phone,
      "orderId": this.props.Data.id,
      "customerId": null,
      "driverId": null,
      "dispatcherId": get_id()
    }))
  }


  getTodayTomorowYesterday = (datexx) => {
    let date = new Date(datexx);


    return `${jalali(datexx).locale(get_lang()).format(checkTimestamp(datexx))}`;

  }





  render() {
    let data = this.props.pickup_dropoff_details && this.props.pickup_dropoff_details.data
    let isCustomerDriver = this.props.pickup_dropoff_details && this.props.pickup_dropoff_details.isCustomerDriver
    let isBussiness = this.props.pickup_dropoff_details && this.props.pickup_dropoff_details.isBussiness

    let order_customFieldDefinitions = this.props.pickup_dropoff_details && this.props.pickup_dropoff_details.order_customFieldDefinitions
    let customField = this.props.pickup_dropoff_details && this.props.pickup_dropoff_details.customField

    let type = this.props.pickup_dropoff_details && this.props.pickup_dropoff_details.type
    let orderType = this.props.Data && this.props.Data.type
    let isPickupDelivery = this.props.Data && this.props.Data.isPickupDelivery
    let isOptionType = data && isArray(data)

    console.log("dasdsdsd", this.props)

    return (

      <div className={clsx(styles.EventTimeLineContainer, data && styles.EventTimeLineContainerOpen)}>

        <div className={styles.EventTimeLine_Header}>
          <img onClick={this.close} className={styles.close} src={close} />
          <span className={styles.eventsTitle}> <Trans i18nKey={data && type}> </Trans> </span>
        </div>

        {(data && !isOptionType && !isCustomerDriver) && <div className={styles.card}>
          <img src={type == "Pickup2" ? pickupdot : dropoffdot} className={styles.pdsicon} />
          <div className={styles.type1Container}>
            <p style={{ fontWeight: "500" }}> {data.address} </p>
            {orderType == "Ondemand" ? <Typography weight="Subtitle_Tiny_Regular" text={<>{data.buildingBlock.length > 0
              ? data.buildingBlock : "" + `${(data.floor.length > 0 && data.buildingBlock.length > 0) ? ", " : ""}`}
              {data.floor.length > 0
                ? data.floor : "" + `${data.room.length > 0 ? `, ${data.room}` : ""}`}

              {(data.buildingBlock.length == 0 && data.floor.length == 0 && data.room.length == 0) && "--------"}
            </>
            } />
              :

              <Typography weight="Subtitle_Tiny_Regular" text={data.addressDetail?.length > 0 ? data.addressDetail : "--------"} />
            }

            {(orderType == "PickupDelivery" && (data.stop?.position || ["Failed", "Successful"].indexOf(data.stop?.status) > -1 || (data?.completeAfter || data.completeAfter > 0) || data?.realETA)) && <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignContent: "center", gap: "6px", flexWrap: "wrap", justifyContent: "start" }}>
              {["Failed", "Successful"].indexOf(data.stop?.status) > -1 && <Tag iconSize="16" backgroundColor="GrayUltraLight" color="TextNormal" size="Medium" weight="Body_Small_Regular" icon={data.stop.status == "Successful" ? DONE_CIRCLE : ic_fail} text={`${this.getTodayTomorowYesterday(data?.stop?.statusUpdatedAt)} `} />}


              {data.stop?.position && <Tag iconSize="16" backgroundColor="GrayUltraLight" color={"TextNormal"} size="Medium" weight="Body_Small_Regular" icon={type == "Pickup2" ? PickupOnly_Deactive : Deliveryonly_deactive} text={`Stop ${data.stop?.position}`} />}

              {(data?.realETA && (!data?.stop || ["Successful", "Failed"].indexOf(data?.stop?.status) == -1)) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={TIMER} text={`ETA: ${this.getTodayTomorowYesterday(data?.realETA)} `} iconSize='14' weight='Body_Tiny_Regular' />}

              {(data?.completeAfter || data.completeAfter > 0) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={calendar_time_gray} text={`${this.getTodayTomorowYesterday(data?.completeAfter)} ${momentJalaali(data?.completeBefore).locale(get_calendarType()).format(` - ${get_timeFormat()}`)}`} iconSize='14' weight='Body_Tiny_Regular' />}

            </div>}

            {this.reserveIsValid() && <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignContent: "center", gap: "6px", flexWrap: "wrap", justifyContent: "start" }}>


              <Tag size='Small' backgroundColor='GrayUltraLight' icon={calendar_time_gray} text={this.reserveToText()} iconSize='14' weight='Body_Tiny_Regular' />

            </div>}



          </div>

          {/* {this.reserveIsValid() && <>
            <hr className={styles.hr} />

            <img src={schedulet1} className={styles.schedulet1} />
            <span className={styles.schedulet}>{this.reserveToText()}</span>
          </>}


          {this.reservePHUBDIsValid() && <>
            <hr className={styles.hr} />

            <img src={schedulet1} className={styles.schedulet1} />
            <span className={styles.schedulet}>{this.reservePHUBDToText()}</span>
          </>}
 */}


          {(data.fullName?.length > 0 || data.phone?.length > 0) && <>
            <hr className={styles.hr} />

            <img src={personv} className={styles.personv} />

            <div className={styles.type2Container} style={{ width: "calc(100% - 132px)" }}>
              <p style={{ fontWeight: "500" }}> {data.fullName?.length > 0 ? data.fullName : "------"} </p>

              <Typography weight="Subtitle_Tiny_Regular" text={data.phone?.length > 0 ? data.phone : "------"} />

            </div>

            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", float: "inline-end" }}>

              {(!global.config.dispatcherSettings.isVoipActvie && data.phone?.length > 0) && <a href={`tel:${data.phone}`}><img className={styles.call} style={{ marginTop: "18px" }} src={call} /></a>
              }
              {(global.config.dispatcherSettings.isVoipActvie && data.phone?.length > 0) && <a onClick={this.makeOutgoingCall}><img className={styles.call} style={{ marginTop: "18px" }} src={call} /></a>
              }
              {data.email?.length > 0 && <a href={`mailto:${data.email}`} ><img className={styles.call} style={{ marginTop: "18px" }} src={email} /></a>
              }
            </div>



          </>}


          {(data?.customerDescription?.length > 0) && <>
            <hr className={styles.hr} />

            <img src={notesv1} className={styles.notesv1} />

            <div className={styles.type2Container}>
              <p> {this.props.t("Notes")} </p>
              <Typography weight="Subtitle_Tiny_Regular" text={data.customerDescription} />

            </div>
          </>
          }




        </div>}


        {(data?.route || data?.zone) && <div className={styles.card}>
          <div className={styles.RouteContainer}>
            {data.zone && <div className={styles.RouteRow}>
              <IconProvider Icon={ic_zoning} size='16' />
              <div className={styles.columnRow}>
                <Typography weight='Body_Middle_Medium' text={data.zone.name} />
                <Typography weight='Subtitle_Tiny_Regular' text={"Zone"} />
              </div>


            </div>}

            {(data?.zone) &&
              <hr className={styles.hrx} />

            }

            <div className={styles.RouteRow}>
              <IconProvider Icon={Routes_deactive} size='16' />
              <div className={styles.columnRow}>
                <Typography weight='Body_Middle_Medium' text={data.route ? data.route.name : "No Route"} />
                <Typography weight='Subtitle_Tiny_Regular' text={this.props.t("Route")} />
              </div>
              {data.route && <div className={styles.columnRow} style={{ height: "33px", marginInlineStart: "8px" }}>
                <Tag className={styles[data.route.status]} text={data.route.status} size='Small' weight='Body_Tiny_Regular' />
              </div>}



              {data.route && <Button onClick={() => { history.push(`/route/${data.route.id}/0`) }} size='Medium' type='Secondary' icon={FORWARD} text='Details' style={{ marginInlineStart: "auto" }} />}
            </div>

            {data.driver && <>
              <hr className={styles.hrx} />

              <div className={styles.RouteRow}>
                <IconProvider Icon={data.driver.avatarPhoto?.length > 0 ? data.driver.avatarPhoto : Customer} size='32' />
                <div className={styles.columnRow} style={{ marginInlineStart: "8px" }}>
                  <Typography weight='Body_Middle_Medium' text={data.driver.name} />
                  <Typography weight='Subtitle_Tiny_Regular' text={"@" + data.driver.username} textColor='TextNormal' />
                </div>



                <img className={styles.call} src={CALL} onClick={() => this.makeOutgoingCall_Driver()} />
              </div>
            </>}

          </div>

        </div>}


        {(orderType == "Ondemand" && type == "Pickup2" && this.props.Data.customerPhoto &&
          String(this.props.Data.customerPhoto).length > 0) && <div className={styles.card}>
            <p className={styles.pod}>{this.props.t(/*"Photos"*/"customerPhoto")}</p>

            <div className={styles.profsContainer} style={{ paddingBottom: "16px" }}>

              <div className={styles.profsItem}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "5.14px"
                  }}
                  src={this.props.Data.customerPhoto}
                />

              </div>

            </div>

          </div>
        }

        {(orderType == "Ondemand" && type == "Pickup2" && !isOptionType && data.proofs.length > 0) && <div className={styles.card}>
          <p className={styles.pod}>{this.props.t(/*"Photos"*/"pop")}</p>

          <div className={styles.profsContainer} style={{ paddingBottom: "16px" }}>

            {data.proofs.map((item) => {
              return <div className={styles.profsItem} style={{position:"relative"}}>

               {["photo", "signature"].indexOf(item.type) > -1 &&  <div className={styles.backdropFilter} 
                  onClick={() => {
                    const myEvent = new CustomEvent("ImageViewer", { detail: item.photoUrl ? item.photoUrl : item.signatureUrl });
                    document.dispatchEvent(myEvent);

                  }} style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "contain",
                    borderRadius: "5.14px",
                    display:"flex",
                    flexDirection:"row",
                    justifyContent:"center",
                    alignItems:"center",
                    position:"absolute",
                    backdropFilter:"blur(1.5px)",
                    opacity:"0"
                  }}>
                  <img style={{width:"20px",height:"20px"}} src={Eye}/>
                </div>}
                {["photo", "signature"].indexOf(item.type) > -1 && <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "5.14px"
                  }}
                  src={item.photoUrl ? item.photoUrl : item.signatureUrl}
                />}
                {['barcode-scan'].indexOf(item.type) > -1 && <div className={styles.innerProofItems}>
                  <img src={ic_barcode_scanned} style={{ marginBottom: "8px" }} />
                  <Typography weight="Body_Tiny_Medium" text={item.barcodeDataKey == "referenceId" ? `Ref.${item.barcodeData}` : `${item.barcodeData}`} style={{ overflowWrap: "break-word", maxWidth: "82px", textAlign: " center" }} />

                </div>
                }

              </div>
            })}

          </div>
          {/* <div className={styles.image}>
            {this.props.Data.customerPhoto &&
              String(this.props.Data.customerPhoto).length > 0 ? (
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
                src={this.props.Data.customerPhoto}
              />
            ) : (
              <span className="nophotosign" style={{ marginTop: "62px" }} >
                {" "}
                <img src={ic_no_photo} />
              </span>
            )}
          </div>
          <div className={styles.image}>
            {this.props.Data.driverPhoto && String(this.props.Data.driverPhoto).length > 0 ? (
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
                src={this.props.Data.driverPhoto}
              />
            ) : (
              <span className="nophotosign" style={{ marginTop: "62px" }}>
                {" "}
                <img src={ic_no_photo} />
              </span>
            )}
          </div>

          <span className={styles.Signature}> {this.props.t("customerPhoto")} </span>
          <span className={styles.Photo}> {this.props.t("driverPhoto")} </span> */}

          {(data.popNote &&
            data.popNote.length > 0) && <><hr className={styles.hr} />

              <img src={notesv1} className={styles.notesv1} />

              <div className={styles.type2Container}>
                <p> {this.props.t("Notes")} </p>
                <Typography weight="Subtitle_Tiny_Regular" text={<>{data.popNote &&
                  data.popNote.length > 0
                  ? data.popNote
                  : this.props.t("Nonotes")}</>} />

              </div></>}

       


        </div>
        }

        {(data && !((orderType == "Ondemand" && type == "Pickup2")) && !(orderType == "PickupDelivery" && type == "Pickup2") && !isOptionType && type == "Dropoff2" && data.proofs.length > 0) && <div id={"x444"} className={styles.card}>
          <p className={styles.pod}>{(orderType == "Pickup") ? this.props.t("pop") : this.props.t("pod")}</p>
          {/* <div className={styles.image}>
            {data.podSignature &&
              String(data.podSignature).length > 0 ? (
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
                src={data.podSignature}
              />
            ) : (
              <span className="nophotosign" style={{ marginTop: "62px" }} >
                {" "}
                <img src={ic_no_photo} />
              </span>
            )}
          </div>
          <div className={styles.image}>
            {data.podPhoto && String(data.podPhoto).length > 0 ? (
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
                src={data.podPhoto}
              />
            ) : (
              <span className="nophotosign" style={{ marginTop: "62px" }}>
                {" "}
                <img src={ic_no_photo} />
              </span>
            )}
          </div>

          <span className={styles.Signature}> {this.props.t("Signature")} </span>
          <span className={styles.Photo}> {this.props.t("Photo")} </span> */}

          <div className={styles.profsContainer} style={{ paddingBottom: "16px" }}>

            {data.proofs.map((item) => {
              return <div className={styles.profsItem} style={{position:"relative"}}>

               {["photo", "signature"].indexOf(item.type) > -1 &&  <div className={styles.backdropFilter} 
                  onClick={() => {
                    const myEvent = new CustomEvent("ImageViewer", { detail: item.photoUrl ? item.photoUrl : item.signatureUrl });
                    document.dispatchEvent(myEvent);

                  }} style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "contain",
                    borderRadius: "5.14px",
                    display:"flex",
                    flexDirection:"row",
                    justifyContent:"center",
                    alignItems:"center",
                    position:"absolute",
                    backdropFilter:"blur(1.5px)",
                    opacity:"0"
                  }}>
                  <img style={{width:"20px",height:"20px"}} src={Eye}/>
                </div>}
                {["photo", "signature"].indexOf(item.type) > -1 && <img 
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "5.14px"
                  }}
                  src={item.photoUrl ? item.photoUrl : item.signatureUrl}
                />}
                {['barcode-scan'].indexOf(item.type) > -1 && <div className={styles.innerProofItems}>
                  <img src={ic_barcode_scanned} style={{ marginBottom: "8px" }} />
                  <Typography weight="Body_Tiny_Medium" text={item.barcodeDataKey == "referenceId" ? `Ref.${item.barcodeData}` : `${item.barcodeData}`} style={{ overflowWrap: "break-word", maxWidth: "82px", textAlign: " center" }} />

                </div>
                }

              </div>
            })}

          </div>

          {(data.podNote &&
            data.podNote.length > 0) && <><hr className={styles.hr} />

              <img src={notesv1} className={styles.notesv1} />

              <div className={styles.type2Container}>
                <p> {this.props.t("Notes")} </p>
                <Typography weight="Subtitle_Tiny_Regular" text={<>{data.podNote &&
                  data.podNote.length > 0
                  ? data.podNote
                  : this.props.t("Nonotes")}</>} />

              </div></>}




        </div>
        }


        {(data && !((orderType == "Ondemand" && type == "Pickup2")) && !(orderType == "PickupDelivery" && type == "Pickup2") && !isOptionType && type == "Pickup2" && data.proofs.length > 0) && <div className={styles.card}>
          <p className={styles.pod}>{(orderType == "Pickup") ? this.props.t("pop") : this.props.t("pod")}</p>

          <div className={styles.profsContainer} style={{ paddingBottom: "16px" }}>

            {data.proofs.map((item) => {
              return <div className={styles.profsItem} style={{position:"relative"}}>

               {["photo", "signature"].indexOf(item.type) > -1 &&  <div className={styles.backdropFilter} 
                  onClick={() => {
                    const myEvent = new CustomEvent("ImageViewer", { detail: item.photoUrl ? item.photoUrl : item.signatureUrl });
                    document.dispatchEvent(myEvent);

                  }} style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "contain",
                    borderRadius: "5.14px",
                    display:"flex",
                    flexDirection:"row",
                    justifyContent:"center",
                    alignItems:"center",
                    position:"absolute",
                    backdropFilter:"blur(1.5px)",
                    opacity:"0"
                  }}>
                  <img style={{width:"20px",height:"20px"}} src={Eye}/>
                </div>}
                {["photo", "signature"].indexOf(item.type) > -1 && <img 
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "5.14px"
                  }}
                  src={item.photoUrl ? item.photoUrl : item.signatureUrl}
                />}
                {['barcode-scan'].indexOf(item.type) > -1 && <div className={styles.innerProofItems}>
                  <img src={ic_barcode_scanned} style={{ marginBottom: "8px" }} />
                  <Typography weight="Body_Tiny_Medium" text={item.barcodeDataKey == "referenceId" ? `Ref.${item.barcodeData}` : `${item.barcodeData}`} style={{ overflowWrap: "break-word", maxWidth: "82px", textAlign: " center" }} />

                </div>
                }

              </div>
            })}

          </div>


          <hr className={styles.hr} />

          <img src={notesv1} className={styles.notesv1} />

          <div className={styles.type2Container}>
            <p> {this.props.t("Notes")} </p>
            <Typography weight="Subtitle_Tiny_Regular" text={<>{data.popNote &&
              data.popNote.length > 0
              ? data.popNote
              : this.props.t("Nonotes")}</>} />

          </div>

        </div>
        }



        {(data && ((orderType == "PickupDelivery" && type == "Pickup2")) && !isOptionType && data.proofs.length > 0) && <div id={"x111"} className={styles.card}>
          <p className={styles.pod}>{this.props.t("pop")}</p>

          <div className={styles.profsContainer} style={{ paddingBottom: "16px" }}>

            {data.proofs.map((item) => {
              return <div className={styles.profsItem} style={{position:"relative"}}>

               {["photo", "signature"].indexOf(item.type) > -1 &&  <div className={styles.backdropFilter} 
                  onClick={() => {
                    const myEvent = new CustomEvent("ImageViewer", { detail: item.photoUrl ? item.photoUrl : item.signatureUrl });
                    document.dispatchEvent(myEvent);

                  }} style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "contain",
                    borderRadius: "5.14px",
                    display:"flex",
                    flexDirection:"row",
                    justifyContent:"center",
                    alignItems:"center",
                    position:"absolute",
                    backdropFilter:"blur(1.5px)",
                    opacity:"0"
                  }}>
                  <img style={{width:"20px",height:"20px"}} src={Eye}/>
                </div>}
                {["photo", "signature"].indexOf(item.type) > -1 && <img 
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "5.14px"
                  }}
                  src={item.photoUrl ? item.photoUrl : item.signatureUrl}
                />}
                {['barcode-scan'].indexOf(item.type) > -1 && <div className={styles.innerProofItems}>
                  <img src={ic_barcode_scanned} style={{ marginBottom: "8px" }} />
                  <Typography weight="Body_Tiny_Medium" text={item.barcodeDataKey == "referenceId" ? `Ref.${item.barcodeData}` : `${item.barcodeData}`} style={{ overflowWrap: "break-word", maxWidth: "82px", textAlign: " center" }} />

                </div>
                }

              </div>
            })}

          </div>


          {(data.podNote &&
            data.podNote.length > 0) && <><hr className={styles.hr} />

              <img src={notesv1} className={styles.notesv1} />

              <div className={styles.type2Container}>
                <p> {this.props.t("Notes")} </p>
                <Typography weight="Subtitle_Tiny_Regular" text={<>{data.podNote &&
                  data.podNote.length > 0
                  ? data.podNote
                  : this.props.t("Nonotes")}</>} />

              </div></>}

          {(data.popNote &&
            data.popNote.length > 0) && <><hr className={styles.hr} />

              <img src={notesv1} className={styles.notesv1} />

              <div className={styles.type2Container}>
                <p> {this.props.t("Notes")} </p>
                <Typography weight="Subtitle_Tiny_Regular" text={<>{data.popNote &&
                  data.popNote.length > 0
                  ? data.popNote
                  : this.props.t("Nonotes")}</>} />

              </div></>}

        </div>
        }




        {
          isOptionType && <div className={styles.card} style={{ display: "flex", flexDirection: "column", gap: "8px", padding: "16px 0px" }}>

            {data.map((opt) => {
              return <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", height: "24px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px" }}>{opt.title}</span>

                {opt.type == "list" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={list_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={opt.dataTitle} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {(opt.type != "list" && opt.type != "boolean") && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={opt.inputValue} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {/* <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px" }}>{opt.type == "list" ? (opt.dataTitle) : (opt.type == "boolean" ? this.props.t("confirmCancel") : opt.inputValue)}</span> */}
              </div>
            })}

            {order_customFieldDefinitions?.filter((item) => { return customField[item.key] }).length > 0 && <div className={styles.titleOptionsRow} >
              <Typography text={this.props.t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
              <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
            </div>
            }

            {order_customFieldDefinitions?.filter((item) => { return customField[item.key] }).map((opt) => {
              return <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: (opt.config.type == "multiLine" || opt.config.type == "singleLine") ? "baseline" : "center"}}>
                <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{opt.label}</EllipisWithTooltip></span>
                {/* {opt.config.type == "file" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "189px", height: "16px", padding: "4px", gap: "4px", justifyContent: "center", alignItems: "center" }}>{customField[opt.key]}</span>}   */}
                {/* <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "189px", height: "16px", padding: "4px", gap: "4px", justifyContent: "center", alignItems: "center" }}>{customField[opt.key]}</span> */}

                {opt.config.type == "file" && <span onClick={() => {
                  window.open(customField[opt.key].url)
                }} style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "rgba(128, 128, 128, 0.06)", border: "1px solid rgba(244, 244, 247, 1)" }}>
                  <img src={AttachColor} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key].name} style={{
                    fontSize: "13px", fontWeight: "400", color: "rgba(36, 36, 36, 1)",
                    textDecoration: 'none',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'

                  }} />
                </span>}

                {opt.config.type == "dateTime" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={calendar_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={jalali(new Date(customField[opt.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(customField[opt.key]))}`)} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "date" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={calendar_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={jalali(new Date(customField[opt.key])).locale(get_lang()).format(` ${get_dateFormat()}`)} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "singleLine" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" ,whiteSpace:"pre-line" }} />
                </span>}

                {opt.config.type == "phone" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "email" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {opt.config.type == "multiLine" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" ,whiteSpace:"pre-line" }} />
                </span>}
                {opt.config.type == "number" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={hashtag2} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "decimalNumber" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={hashtag2} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {opt.config.type == "select" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={list_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={opt.config?.choices[opt.config?.choices.findIndex((item) => { return item.key == customField[opt.key] })]?.label} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}



              </div>
            })}

          </div>
        }



        {
          (!isOptionType && order_customFieldDefinitions && order_customFieldDefinitions?.filter((item) => { return customField[item.key] }).length > 0) && <div className={styles.card} style={{ display: "flex", flexDirection: "column", gap: "8px", padding: "12px 0px" }}>


            {order_customFieldDefinitions?.filter((item) => { return customField[item.key] }).length > 0 && <Typography text={this.props.t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(36, 36, 36, 1)", fontSize: "14px", fontWeight: "500", marginInlineStart: "16px" }} />
            }

            {order_customFieldDefinitions?.filter((item) => { return customField[item.key] }).map((opt) => {
              return <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: (opt.config.type == "multiLine" || opt.config.type == "singleLine") ? "baseline" : "center"}}>
                <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{opt.label}</EllipisWithTooltip></span>
                {/* {opt.config.type == "file" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "189px", height: "16px", padding: "4px", gap: "4px", justifyContent: "center", alignItems: "center" }}>{customField[opt.key]}</span>}   */}
                {/* <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "189px", height: "16px", padding: "4px", gap: "4px", justifyContent: "center", alignItems: "center" }}>{customField[opt.key]}</span> */}

                {opt.config.type == "file" && <span onClick={() => {
                  window.open(customField[opt.key].url)
                }} style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "rgba(128, 128, 128, 0.06)", border: "1px solid rgba(244, 244, 247, 1)" }}>
                  <img src={AttachColor} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key].name} style={{
                    fontSize: "13px", fontWeight: "400", color: "rgba(36, 36, 36, 1)",
                    textDecoration: 'none',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'

                  }} />
                </span>}

                {opt.config.type == "dateTime" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={calendar_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={jalali(new Date(customField[opt.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(customField[opt.key]))}`)} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "date" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={calendar_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={jalali(new Date(customField[opt.key])).locale(get_lang()).format(` ${get_dateFormat()}`)} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "singleLine" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" ,whiteSpace:"pre-line" }} />
                </span>}

                {opt.config.type == "phone" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "email" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {opt.config.type == "multiLine" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" ,whiteSpace:"pre-line" }} />
                </span>}
                {opt.config.type == "number" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={hashtag2} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "decimalNumber" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={hashtag2} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={customField[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {opt.config.type == "select" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={list_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={opt.config?.choices[opt.config?.choices.findIndex((item) => { return item.key == customField[opt.key] })]?.label} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}



              </div>
            })}

          </div>
        }



        {
          (isCustomerDriver && this.props.pickup_dropoff_details.type == "Customerinfo") && <div className={styles.card} style={{ display: "flex", flexDirection: "column", gap: "8px", padding: "16px 0px" }}>


            {!isBussiness && <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Fname")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                <img src={input} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.givenName} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>}


            {!isBussiness && <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Lname")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                <img src={input} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.familyName} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>}

            {isBussiness && <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Businessname")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                <img src={input} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.name} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>
            }


            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Phone")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "rgba(128, 128, 128, 0.06)", border: "1px solid rgba(244, 244, 247, 1)" }}>
                <img src={call} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.phone} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>

            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("email")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "rgba(128, 128, 128, 0.06)", border: "1px solid rgba(244, 244, 247, 1)" }}>
                <img src={email_color} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.email} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>

            {data?.customFieldDefinitions?.filter((item) => { return data?.customFields[item.key] }).length > 0 && <div className={styles.titleOptionsRow} >
              <Typography text={this.props.t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
              <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
            </div>
            }

            {data?.customFieldDefinitions?.filter((item) => { return data?.customFields[item.key] }).map((opt) => {
              return <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: (opt.config.type == "multiLine" || opt.config.type == "singleLine") ? "baseline" : "center"}}>
                <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{opt.label}</EllipisWithTooltip></span>

                {opt.config.type == "file" && <span onClick={() => {
                  window.open(data?.customFields[opt.key].url)
                }} style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "rgba(128, 128, 128, 0.06)", border: "1px solid rgba(244, 244, 247, 1)" }}>
                  <img src={AttachColor} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key].name} style={{
                    fontSize: "13px", fontWeight: "400", color: "rgba(36, 36, 36, 1)",
                    textDecoration: 'none',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'

                  }} />
                </span>}

                {opt.config.type == "dateTime" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={calendar_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={jalali(new Date(data?.customFields[opt.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(data?.customFields[opt.key]))}`)} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "date" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={calendar_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={jalali(new Date(data?.customFields[opt.key])).locale(get_lang()).format(` ${get_dateFormat()}`)} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "singleLine" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" ,whiteSpace:"pre-line"}} />
                </span>}

                {opt.config.type == "phone" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "email" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {opt.config.type == "multiLine" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" ,whiteSpace:"pre-line"}} />
                </span>}
                {opt.config.type == "number" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={hashtag2} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "decimalNumber" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={hashtag2} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {opt.config.type == "select" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={list_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={opt.config?.choices[opt.config?.choices.findIndex((item) => { return item.key == data?.customFields[opt.key] })]?.label} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}



              </div>
            })}

          </div>
        }


        {
          (isCustomerDriver && this.props.pickup_dropoff_details.type == "Driverinfo") && <div className={styles.card} style={{ display: "flex", flexDirection: "column", gap: "8px", padding: "16px 0px" }}>


            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Fullname")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                <img src={input} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.name} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>


            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("username")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                <img src={input} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.username} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>




            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Phone")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "rgba(128, 128, 128, 0.06)", border: "1px solid rgba(244, 244, 247, 1)" }}>
                <img src={call} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.phone} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>

            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("email")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "rgba(128, 128, 128, 0.06)", border: "1px solid rgba(244, 244, 247, 1)" }}>
                <img src={email_color} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.email} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>


            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Vehicle")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                <img src={input} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.vehicle?.color + " " + data?.vehicle?.model} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>

            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Plate")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                <img src={input} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.vehicle?.plate} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>

            <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "baseline" }}>
              <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{this.props.t("Vehicletyps")}</EllipisWithTooltip></span>
              <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                <img src={input} style={{ width: "14px" }} />
                <Typography weight="Body_Middle_Medium" text={data?.vehicleTypes.map(item => item.title).join(", ")} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
              </span>
            </div>


            {data?.customFieldDefinitions?.filter((item) => { return data?.customFields[item.key] }).length > 0 && <div className={styles.titleOptionsRow} >
              <Typography text={this.props.t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
              <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
            </div>
            }

            {data?.customFieldDefinitions?.filter((item) => { return data?.customFields[item.key] }).map((opt) => {
              return <div style={{ width: "calc(100% - 32px)", marginLeft: "16px", marginRight: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: (opt.config.type == "multiLine" || opt.config.type == "singleLine") ? "baseline" : "center" }}>
                <span style={{ color: "rgba(72, 72, 72, 1)", fontWeight: "400", fontSize: "13px", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "108px" }}><EllipisWithTooltip>{opt.label}</EllipisWithTooltip></span>

                {opt.config.type == "file" && <span onClick={() => {
                  window.open(data?.customFields[opt.key].url)
                }} style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "rgba(128, 128, 128, 0.06)", border: "1px solid rgba(244, 244, 247, 1)" }}>
                  <img src={AttachColor} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key].name} style={{
                    fontSize: "13px", fontWeight: "400", color: "rgba(36, 36, 36, 1)",
                    textDecoration: 'none',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'

                  }} />
                </span>}

                {opt.config.type == "dateTime" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={calendar_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={jalali(new Date(data?.customFields[opt.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(data?.customFields[opt.key]))}`)} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "date" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={calendar_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={jalali(new Date(data?.customFields[opt.key])).locale(get_lang()).format(` ${get_dateFormat()}`)} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "singleLine" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" ,whiteSpace:"pre-line" }} />
                </span>}

                {opt.config.type == "phone" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "email" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {opt.config.type == "multiLine" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", minHeight: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "start", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={input} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" ,whiteSpace:"pre-line" }} />
                </span>}
                {opt.config.type == "number" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={hashtag2} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}

                {opt.config.type == "decimalNumber" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={hashtag2} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={data?.customFields[opt.key]} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}


                {opt.config.type == "select" && <span style={{ fontWeight: "400", color: "#242424", fontSize: "13px", width: "180px", height: "16px", cursor: "pointer", padding: "4px", gap: "4px", justifyContent: "start", display: "flex", alignItems: "center", borderRadius: "4px", backgroundColor: "transparent", border: "1px solid transparent" }}>
                  <img src={list_gray} style={{ width: "14px" }} />
                  <Typography weight="Body_Middle_Medium" text={opt.config?.choices[opt.config?.choices.findIndex((item) => { return item.key == data?.customFields[opt.key] })]?.label} style={{ fontSize: "13px", fontWeight: "400", color: "rgba(72, 72, 72, 1)" }} />
                </span>}



              </div>
            })}

          </div>
        }



      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  pickup_dropoff_details: state.ViewTravel.pickup_dropoff_details,
  showEventTimeLine: state.ViewTravel.eventTimeLine.show,
  Data: state.ViewTravel.pureData ? state.ViewTravel.pureData : false,
  baseFarePrice: state.ViewTravel.pureData
    ? state.ViewTravel.pureData.baseFarePrice
    : 0,
  surcharges: state.ViewTravel.pureData
    ? state.ViewTravel.pureData.surcharges
    : [],

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
